import { IDocumentsCell } from '../../../types/IDocumentsCell';

import LoadingCell from '../../../../ui/table/cells/loadingCell/loadingCell';

import './chipsCell.scss';

const ChipsCell: React.FC<IDocumentsCell> = ({ rowType, dataItem, field, useTooltip, treelist, style, className }) => {
  if (rowType === 'groupHeader') {
    return null;
  }

  if (dataItem[field] === undefined && treelist) return <td style={style} className={className} />;
  if (dataItem[field] === undefined) return <LoadingCell />;

  let title = '';

  let chips = dataItem[field]
    ? dataItem[field].map((cv, i) => {
      if (i > 0)
        title += ', ';
      title += cv.name;

      return (
        <div className='chips' key={i}>
          {cv.name}
        </div>
      );
    })
    : 'none';

  return (
    <td style={style} className={className}>
      <div className='chips-cell' title={useTooltip ? title : ''}>
        {chips}
      </div>
    </td>
  );
};

export default ChipsCell;
